import { IFolderPath } from '@core/entities/folders/FolderPath'

const useFolderPath = () => {
  const pathText = (pathFromRoot: IFolderPath) => {
    const withoutRootAndSelf = pathFromRoot
      ?.filter((f) => f.displayName !== 'ROOT')
      ?.slice(0, -1)
    if (!withoutRootAndSelf?.length) {
      return null
    }
    return `${withoutRootAndSelf?.map((f) => f.displayName).join(' / ')} /`
  }

  return {
    pathText,
  }
}

export default useFolderPath
